import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { checkMobile } from '../../utils/utils'
import CourseMyDetailMobile from './CourseMyDetailMobile.vue'
import CourseMyDetailWeb from './CourseMyDetailWeb.vue'

// Select at entry so a resize cannot discard an in-progress answer.

export default /*@__PURE__*/_defineComponent({
  __name: 'CourseMyDetail',
  setup(__props) {

const mobile = ref(checkMobile() || window.matchMedia('(max-width: 700px)').matches)

return (_ctx: any,_cache: any) => {
  return (mobile.value)
    ? (_openBlock(), _createBlock(CourseMyDetailMobile, { key: 0 }))
    : (_openBlock(), _createBlock(CourseMyDetailWeb, { key: 1 }))
}
}

})